/**
 * The message to show under a field.
 *
 * Client-side messages are i18next keys, because the zod schemas carry keys rather than English.
 * Server-side ones arrive already written, and are marked `type: "server"` by `applyAuthError`.
 */

import type { FieldErrors, FieldValues, Path } from "react-hook-form";
import type { TFunction } from "i18next";

export function fieldMessage<TValues extends FieldValues>(
  errors: FieldErrors<TValues>,
  field: Path<TValues>,
  t: TFunction,
): string | undefined {
  const error = errors[field];
  if (!error) return undefined;
  const { message, type } = error as { message?: unknown; type?: unknown };
  if (typeof message !== "string") return undefined;
  return type === "server" ? message : t(message);
}
